// extracted by mini-css-extract-plugin
export default {"wrapper":"City_wrapper__U-wJv","footer":"City_footer__i4YhD","button":"City_button__tvNeB","closeContainer":"City_closeContainer__xQ2p8"};